import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import residenceIdentificationPlateListAction from './residenceIdentificationPlateList.action.json' with { type: 'json' }
import {
  residenceIdentificationPlateListItemObject,
  residenceIdentificationPlateObject,
} from '../residenceIdentificationPlateObject'

export const residenceIdentificationPlateExpression = expression(
  residenceIdentificationPlateListItemObject.shape,
)

const residenceIdentificationPlateListDefinition = defineAction({
  ...residenceIdentificationPlateListAction,

  input: z.object({
    filter: residenceIdentificationPlateExpression.nullish(),
    residenceId: residenceIdentificationPlateObject.shape.residenceId.nullish(),
    manufactured: z.boolean().nullish(),
    delivered: z.boolean().nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      code: 'Codigo da placa',
      residenceCode: 'Codigo da residencia',
      manufacturedAt: 'Data de confeccao',
      deliveredAt: 'Data de entrega',
      createdAt: 'Criacao',
      updatedAt: 'Atualizacao',
      synchronizedAt: 'Sincronizacao',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(residenceIdentificationPlateListItemObject),
    count: z.number(),
  }),
})

export default residenceIdentificationPlateListDefinition
